import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui';

const user = {
  state: {
    token: getToken(),
    name: '',
    id: '',
    merchantId: '',
    avatar: '',
    roles: [],
    platId: null,
    platName: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PLATID: (state, platId) => {
      state.platId = platId
    },
    SET_PLATNAME: (state, platName) => {
      state.platName = platName
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_MERCHANT_ID: (state, merchantId) => {
      state.merchantId = merchantId;
    }

  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          let rej = {
            customs: 1
          }
          const data = response.data
          let msg = data.msg;
          if (msg != 'wait' && msg != 'reject') {
            const tokenStr = data.tokenHead + data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve();
          } else if (msg == 'wait') {
            Message.info('请等待管理员完成审核');
            reject(rej);
          } else if (msg == 'reject') {
            Message.error('注册账号已被驳回,请修改')
            rej.customs = '2'
            rej.reason = data.reason;
            rej.id = data.id;
            reject(rej);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          console.log(data,'getInfo');
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_ID', data.userId)
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_PLATID', data.platId)
          // if (data.userId != 3) {
          commit('SET_MERCHANT_ID', data.merchantId)
          // }
          if (data.platId !== null) {
            commit('SET_PLATNAME', data.platName)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    ChangeMerchantId({commit,newId}){
      return new Promise((resolve,reject)=>{
        commit('SET_MERCHANT_ID',newId)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js